import { createGlobalStyle } from "styled-components";

const Style = createGlobalStyle`
.btn-nodemo-secondary {
	width: 100%;
	border: none;
	border-radius: 0px;
	padding: 10px 18px;
	text-align: left;
	font-family: inherit;
    background: inherit;
	color: #848484;
    &:hover,
    &:focus,
    &:active:focus,
    &:active {
        color: #848484;
	    background: inherit;
        outline: none;
        box-shadow: none;
    }
}

.nodemo-secondary-sub-dropdown .dropdown-menu li span {
	white-space: nowrap;
}

`;

export default Style;
